import React, {useEffect} from 'react';
import {Route} from "react-router-dom";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import BsPanel from "components/panel/BsPanel";
import {fetchBicycleInfo} from "core/actions/bicycle-actions";
import GeneralBicycleInfoTab from "./tabs/info/GeneralBicycleInfoTab";
import GeneralBicycleRentalsTab from "./tabs/rentals/GeneralBicycleRentalsTab";
import GeneralBicycleProblemsTab from "./tabs/problems/GeneralBicycleProblemsTab";
import GeneralBicycleReportsTab from "./tabs/reports/GeneralBicycleReportsTab";

function GeneralBicycleInfo(props) {
  const lastSegment = props.location.pathname.replace(props.match.url, '').replace('/', '')
  const defaultTab = lastSegment.split('?')[0]
  const [value, setValue] = React.useState(defaultTab ? defaultTab : 'info');
  const [currentBicycleLoaded, setCurrentBicycleLoaded] = React.useState(false);
  const {t} = useTranslation();

  useEffect(() => {
    if (!currentBicycleLoaded) {
      props.fetchBicycleInfo(props.match.params.bicycleId);
      setCurrentBicycleLoaded(true);
    }
  }, []);

  const handleChange = (event, newValue) => {
    if (value !== newValue) {
      props.history.push((props.match.url + '/' + newValue).replace('//', '/'))
    }
    setValue(newValue);
  };

  if (props.currentBicycle) {
    return (
        <BsPanel>
          <Tabs value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary">
            <Tab label={t('bicycle_info.info_tab') + props.currentBicycle.number} value="info"/>
            <Tab label={t('bicycle_info.rentals_tab')} value="rentals"/>
            <Tab label={t('bicycle_info.reported_problems_tab')} value="reported-problems"/>
            <Tab label={t('bicycle_info.reports_tab')} value="reports"/>
          </Tabs>

          <Route exact path="/global/bicycle/:bicycleId" component={GeneralBicycleInfoTab}/>
          <Route path="/global/bicycle/:bicycleId/info" component={GeneralBicycleInfoTab}/>
          <Route path="/global/bicycle/:bicycleId/rentals" component={GeneralBicycleRentalsTab}/>
          <Route path="/global/bicycle/:bicycleId/reported-problems" component={GeneralBicycleProblemsTab}/>
          <Route path="/global/bicycle/:bicycleId/reports" component={GeneralBicycleReportsTab}/>
        </BsPanel>
    );
  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentBicycle: state.bicycle.currentBicycle
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBicycleInfo: (bicycleId) => {
      dispatch(fetchBicycleInfo(bicycleId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralBicycleInfo);
